import apiStore from './index';
import { paths }  from '@src/consts/apiPaths';

const logger = Logger.get('apis/plans');

const getPlansPath = ( subID = '' ) => `${ paths.plans }/${ subID }`;
const getverifypaymentPath = ( payId = '' ) => `${ paths.paymentverification }/${ payId }`;

const fetchUserPlan = async ( payload = {} ) => {
    
    try {
        const { subscriberId } = payload ;

        const path = getPlansPath( subscriberId );

        let { data: body } = await apiStore.axios.get( path );
        
        if( !body.planid ) throw new Error('no registered plans');

        return body ;
    }
    catch( error ){
        logger.log( error );
        return  [];
    } 
}

const fetchPlans = async () => {
    try {

        let { data: body } = await apiStore.axios.get( paths.plans );
        
        if( !Array.isArray( body.data ) ) throw new Error('no registered plans');

        return body.data ;
    }
    catch( error ){
        logger.log( error );
        return  [];
    } 
}

const verifyUserPayment = async ( payload = {} ) => {
    
    try {
        const  {paymentid}  = payload;

        const params = {"paymentid":paymentid,"gatewayprovider":"PAYTM"}


        const { data:body } = await apiStore.axios.get( paths.paymentverification,  {params} );
    
        if( !body.paymentid ) throw new Error('no payment exits');

        return body ;
    }
    catch( error ){
        logger.log( error );
        return  body;
    } 
}

export {
    fetchPlans,
    fetchUserPlan,
    verifyUserPayment
}
